import { useTranslation } from 'react-i18next'
import classNames from 'classnames'

import { useContentOverflow } from '../../../hooks'
import { getQaSelector } from '../../../utils/common'
import { Counter } from '../../Counter'
import { FloatingTooltip } from '../../Floating'

import { QA_NAME_SUBMENU } from './SubMenuItem.constants'

import * as styles from './SubMenuItem.module.css'

function SubMenuItem({
  apiKeys,
  className = styles.SubMenuItem,
  count,
  isNested,
  item,
  selected,
  onClick,
}) {
  const { t } = useTranslation()

  const subMenuItemClassName = classNames(className, {
    [styles.active]: selected,
    [styles.nested]: isNested,
  })

  const { overflow, setContentOverflowRef } = useContentOverflow()

  function handleClick() {
    onClick(item[apiKeys.value])
  }

  const qaProps = getQaSelector({
    context: QA_NAME_SUBMENU,
    value: item[apiKeys.value],
  })

  return (
    <div {...qaProps} className={subMenuItemClassName} onClick={handleClick}>
      <FloatingTooltip content={t(item[apiKeys.label])} disabled={!overflow}>
        <span className={styles.label} ref={setContentOverflowRef}>
          {t(item[apiKeys.label])}
        </span>
      </FloatingTooltip>
      {count > 0 ? (
        <div className={styles.counter}>
          <Counter count={count} />
        </div>
      ) : null}
    </div>
  )
}

export default SubMenuItem
